export default __webpack_public_path__ + "static/brun-f18dfd3114170c6c3fd54d71811a474f.svg";